export default __webpack_public_path__ + "static/media/brgy_seal.23fa5cdd.png";